const translate_Results = (variableIds, results) => {
    return variableIds.reduce((map, varId) => {
        const varResults = results[varId];
        if (varResults)
            map[varId] = varResults.results.map(result => {
                return {
                    value: result.value,
                    currentEncounter: result.currentVisit,
                    timestamp: result.timestamp
                };
            });
        return map;
    }, {});
};
const translate_Metadata = (variableIds, results) => {
    return variableIds.reduce((map, varId) => {
        const varResults = results[varId];
        if (varResults)
            map[varId] = {
                measurementUnitId: varResults.measurementUnitId,
                varNormal: varResults.normalRange,
            };
        return map;
    }, {});
};
export const translate_VitalsResult_TooltipData = (section, results) => {
    return {
        variableIds: section.data.variableIds,
        results: translate_Results(section.data.variableIds, results),
        metadata: translate_Metadata(section.data.variableIds, results),
    };
};
//# sourceMappingURL=translate-tooltip-results.js.map